/* eslint-disable warp-drive/no-legacy-request-patterns */
import Route from '@ember/routing/route';

import { service } from '@ember/service';
import { isEmpty } from '@ember/utils';

export default class FinanceRoute extends Route {
  // Services
  @service
  options;

  @service
  store;

  afterModel() {
    let signatureMediaId = this.options.value(
      'finance:school:electronicSignature',
    );
    if (!isEmpty(signatureMediaId)) {
      return this.store.findRecord('media', signatureMediaId);
    }
  }
}
